// extracted by mini-css-extract-plugin
export default {"paddingLeftRight":"Responsive_paddingLeftRight__ZEhxc"};